export const reAdministrativeTerritoryConstants = {
	GetPaged: {
		SUCCESS : 'GET_PAGED_ADMINISTRATIVE_TERRITORY_SUCCESS',
		REQUEST : 'GET_PAGED_ADMINISTRATIVE_TERRITORY_REQUEST',
		FAILURE : 'GET_PAGED_ADMINISTRATIVE_TERRITORY_FAILURE'
	},
	GetPagedAll: {
		REQUEST : 'GET_PAGED_ALL_ADMINISTRATIVE_TERRITORY_REQUEST',
		SUCCESS : 'GET_PAGED_ALL_ADMINISTRATIVE_TERRITORY_SUCCESS',
		FAILURE : 'GET_PAGED_ALL_ADMINISTRATIVE_TERRITORY_FAILURE'
	},
	GetPagedAudit: {
		REQUEST : 'GET_AUDIT_PAGED_ADMINISTRATIVE_TERRITORY_REQUEST',
		SUCCESS : 'GET_AUDIT_PAGED_ADMINISTRATIVE_TERRITORY_SUCCESS',
		FAILURE : 'GET_AUDIT_PAGED_ADMINISTRATIVE_TERRITORY_FAILURE'
	},
	GetList: {
		REQUEST : 'GET_LIST_ADMINISTRATIVE_TERRITORY_REQUEST',
		SUCCESS : 'GET_LIST_ADMINISTRATIVE_TERRITORY_SUCCESS',
		FAILURE : 'GET_LIST_ADMINISTRATIVE_TERRITORY_FAILURE'
	},
	Create: {
		REQUEST : 'CREATE_ADMINISTRATIVE_TERRITORY_REQUEST',
		SUCCESS : 'CREATE_ADMINISTRATIVE_TERRITORY_SUCCESS',
		FAILURE : 'CREATE_ADMINISTRATIVE_TERRITORY_FAILURE'
	},
	Delete: {
		REQUEST : 'DELETE_ADMINISTRATIVE_TERRITORY_REQUEST',
		SUCCESS : 'DELETE_ADMINISTRATIVE_TERRITORY_SUCCESS',
		FAILURE : 'DELETE_ADMINISTRATIVE_TERRITORY_FAILURE'
	},
	Update: {
		REQUEST : 'UPDATE_ADMINISTRATIVE_TERRITORY_REQUEST',
		SUCCESS : 'UPDATE_ADMINISTRATIVE_TERRITORY_SUCCESS',
		FAILURE : 'UPDATE_ADMINISTRATIVE_TERRITORY_FAILURE'
	},
	Restore: {
		REQUEST : 'RESTORE_ADMINISTRATIVE_TERRITORY_REQUEST',
		SUCCESS : 'RESTORE_ADMINISTRATIVE_TERRITORY_SUCCESS',
		FAILURE : 'RESTORE_ADMINISTRATIVE_TERRITORY_FAILURE'
	},

	CLEAR: 'CLEAR_ADMINISTRATIVE_TERRITORY'
}